// The mark: four orange tiles in four sizes (big, tall, wide and small, as widgets can be), the
// same drawing as public/favicon.svg (master in the vault, Brand/logo/context-board.svg).
// It keeps its own colours on every theme. And the name on its own, for the sign-in and
// consent pages, which show no mark (David, 13 Oct: just the name, in white).

export function Mark({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden className="mark">
      <rect x="4" y="4" width="36" height="36" rx="6" fill="#ea580c" />
      <rect x="44" y="4" width="16" height="36" rx="5" fill="#ea580c" />
      <rect x="4" y="44" width="36" height="16" rx="5" fill="#ea580c" />
      <rect x="44" y="44" width="16" height="16" rx="5" fill="#ea580c" />
    </svg>
  );
}

export function Logo() {
  return <span className="logo">Context Board</span>;
}
